// export const TEST_API = "https://testapi.tradexapp.co/v2/";

import {REACT_APP_ENV} from '../../index';
import {partnerMap} from './globalConstant';

console.log("TEST");
export const TEST_API = 
  REACT_APP_ENV === 'prod'
    ? 'https://api.tradexapp.co/v2/'
    : REACT_APP_ENV === 'preprod'
    ? 'https://preprodapi.tradexapp.co/v2/'
    : REACT_APP_ENV === 'staging'
    ? 'https://testapi.theox.co/v2/'
    : REACT_APP_ENV === 'partnerdev' ||
      partnerMap?.isMyMaster ||
      partnerMap?.isTmr
    ? 'https://partnerdevapi.theox.co/v2/'
    : 'https://devapi.theox.co/v2/';

export const TEST_API_D24 =
  REACT_APP_ENV === 'prod'
    ? 'https://web.tradexapp.co/'
    : REACT_APP_ENV === 'preprod'
    ? 'https://web.tradexapp.co/'
    : REACT_APP_ENV === 'staging'
    ? 'https://devweb.theox.co/'
    : 'https://devweb.theox.co/';

export const TEST_API_TRADING =
  REACT_APP_ENV === 'prod'
    ? 'https://trading.tradexapp.co/'
    : REACT_APP_ENV === 'staging'
    ? 'https://devtrading.theox.co/'
    : 'https://devtrading.theox.co/';

export const UPDATE_URL =
  REACT_APP_ENV === 'prod'
    ? 'https://api.tradexapp.co/'
    : REACT_APP_ENV === 'staging'
    ? 'https://devapi.theox.co/'
    : 'https://devapi.theox.co/';

const CONTEST_PREFIX = 'fantasy/contest/';
const apiUtlOtp = 'https://devadminapi.theox.co/v2/';

//
export const APP_UPDATE_URL = `${UPDATE_URL}getapp`;
export const SEND_OTP = `${TEST_API}sendotp`;
export const VERIFY_OTP = `${TEST_API}verifyotpnew`;
export const USER_PROFILE = `${TEST_API}user`;
export const VERIFY_MOBILE = `${TEST_API}verifymobile`;
export const GET_PROBES = `${TEST_API}getProbes`;

export const GET_LIVE_PROBES = `${TEST_API}mybetsv3`;
export const GET_LIVE_PROBES_CONTEST = `${TEST_API}fantasy/mybetsv3`;
export const GET_CONFIG = `${TEST_API}config`;
export const EVENT_DETAIL = `${TEST_API}probecalls/open`;
export const EVENT_DETAIL_CONTEST = `${TEST_API}fantasy/probecalls/open`;

export const CLOSED_MARKET = `${TEST_API}getHistoryMarkets`;
export const BUY_ORDER = `${TEST_API}probe/putcall`;
export const CANCEL_BUY_ORDER = `${TEST_API}event/cancelcall`;
export const BANK_DETAILS = `${TEST_API}bankdetails`;
export const GET_USER = `${TEST_API}getuser`;
export const GET_WALLET_TRANSACTIONS = `${TEST_API}transactions`;
export const GET_EXIT_POSITION = `${TEST_API}event/getexitpositions`;
export const GET_TRADING_FEE = `${TEST_API}tradingfee/cda?noofcontracts={contracts}&price={price}&max_returns={maxReturns}`;
export const SELL_ORDER = `${TEST_API}event/makeexit`;
export const CANCEL_SELL_ORDER = `${TEST_API}event/cancelonhold`;
export const GET_INSTANT_PRICE = `${TEST_API}event/get_true_price?eventId={eventId}&action={action}&callvalue={callValue}&noofcontracts={contracts}`;
export const GET_INSTANT_UPDATED_PRICE = `${TEST_API}event/get_updated_prices?eventId={eventId}&action={action}&callvalue={callValue}&noofcontracts={contracts}&range={range}`;
export const TRADING_FEE = `${TEST_API}tradingfee/cda`;
export const GET_TRUE_PRICE = `${TEST_API}event/get_true_price`;
export const GET_UPDATED_PRICE = `${TEST_API}event/get_updated_prices`;
export const CREATE_ORDER = `${TEST_API}payment/token`;
export const ADD_BANK_DETAILS = `${TEST_API}bankdetails/addNew`;
export const REMOVE_BANK_DETAILS = `${TEST_API}bankdetails/remove`;
export const REDEEM_REQUEST = `${TEST_API}redeem`;
export const CRYPTO_REDEEM_REQUEST = `${TEST_API}redeem/confirm-crypro-payout`;
export const VERIFY_COUPON = `${TEST_API}coupon/validate`;
export const GET_REFERRAL_DATA = `${TEST_API}user/referral`;
export const UPDATE_USER_DETAILS = `${TEST_API}user/update`;
export const SEND_OTP_EMAIL = `${TEST_API}sendotpemail`;
export const VERIFY_OTP_EMAIL = `${TEST_API}verifyotpemail`;
export const CLOSED_MARKET_HEADER = `${TEST_API}getHistory/header`;
export const VERIFY_GOOGLE_TOKEN = `${TEST_API}verifyemail`;
export const GET_MERGE_SHARES_AMOUNT = `${TEST_API}event/mergeyesnotokensnumbers`;
export const GET_ADD_LIQUIDITY_SHARES = `${TEST_API}event/getaddliquiditynumbers`;
export const MERGE_SHARES = `${TEST_API}event/mergeyesnotokens`;
export const MERGE_SHARES_CDA = `${TEST_API}event/mergeorder`;
export const ADD_LIQUIDITY = `${TEST_API}event/addliquidity`;
export const REMOVE_LIQUIDITY = `${TEST_API}event/removeliquidity`;
export const REMOVE_LIQUIDITY_SHARES = `${TEST_API}event/getremoveiquiditynumbers`;
export const POWER_TRADE = `${TEST_API}event/powertrade`;
export const POWER_TRADE_SHARES = `${TEST_API}event/powertrade/amountcheck`;
export const LAST_TXN_STATUS = `${TEST_API}lastpayment/status`;
export const FAQs = `${TEST_API}faqs`;
export const GET_BLOCKED_PINCODE = `${TEST_API}getBlockedPinCode`;
export const FETCHNEWS = `${TEST_API}probe/content`;
export const ADD_BANK_NEW = `${TEST_API}bankdetails/addOnlyBank`;
export const DELETE_ACC = `${TEST_API}bankdetails/remove`;
export const CREATE_ORDER_WEB = `${TEST_API}order/create`;
export const EVENT_REFERRAL = `${TEST_API}event/referral`;
export const ADD_PAYMENT = `${TEST_API}payment`;
export const VERIFY_COUPON_RECHARGE = `${TEST_API}coupon/validatecustomcoupon`;
export const GET_EXCHANGE_RATE = `${TEST_API}exchangeRate`;
export const VALIDATE_WALLET = `${TEST_API}virtualwallet/validate`;
export const FETCH_ORDER_JUSPAY = `${TEST_API}paymentJP`;
export const GET_WP_SESSION = `${TEST_API}otpless/login/start/session/whatsapp`;
export const GET_WP_STATUS = `${TEST_API}otpless/login/session/{sessionId}`;
export const WP_LOGIN_APPROVE = `${TEST_API}otpless/login/approve/session`;

//clubs

export const PLACE_CLUB_ORDER = `${TEST_API_TRADING}bet/{clubId}/{eventId}`;
export const GET_CLUB_EVENT_DETAIL = `${TEST_API}clubs/{clubId}/events/{eventId}`;
export const GET_CLUB_EVENT_UPDATED_ODDS = `${TEST_API}clubs/{clubId}/events/{eventId}/odds`;

export const FETCH_CLUB_DETAILS = `${TEST_API}clubs`;
export const FETCH_CLUB_MARKETS = `${TEST_API}clubs`;

export const CLUBS_LIVE = `${TEST_API}clubs`;

export const CLUBS_CLOSED = `${TEST_API}clubs`;

export const CLUB_SETTLE = `${TEST_API}club/event/update`;
export const CLUB_CREATE = `${TEST_API}clubs/{clubId}/event/create`;

export const TDS_BREAKUP = `${TEST_API}tdsbreakup`;

export const BANNERS = `${TEST_API}banners`;

export const CONTEST_LIVE = `${TEST_API}fantasy/contest/live?format=1,2`;

export const CONTEST_CLOSED = `${TEST_API}fantasy/contest/closed`;

export const ENTER_CONTEST = `${TEST_API}fantasy/contest/entercontest`;

export const CONTEST_EVENTS = `${TEST_API}fantasy/contest/getProbes`;

export const FETCH_ONMETA_ORDER_STATUS = `${TEST_API}payment/onmeta/order/status`;
export const FETCH_PRO_TRADER_DETAILS = `${TEST_API}proTraderIncentive`;
export const ADD_MOBILE = `${TEST_API}addmobileinfo`;
export const SET_PRICE_RANGE = `${TEST_API}rangePreference`;

//lucky coins
export const SMILE_COINS_DETAIL = `${TEST_API}luckycoins/details`;
export const LUCKY_COINS_REDEEM = `${TEST_API}luckycoins/redeem`;
export const LUCKY_COINS_REDEEM_CRYPTO = `${TEST_API}luckycoins/convert/crypto`;
export const LUCKY_COINS_CONFIRM_REDEEM_CRYPTO = `${TEST_API}luckycoins/confirm/convert/crypto`;
export const GET_COUPON_LIST = `${TEST_API}coupon/getcustomcoupon`;
export const SEND_OTP_EMAIL_LOGIN = `${TEST_API}sendotpemaillogin`;
export const VERIFY_OTP_EMAIL_LOGIN = `${TEST_API}verifyotpemaillogin`;

//lucky coins
export const CLAIM_REWARD = `${TEST_API}reward/claim`;
export const GET_REWARD_DETAIL = `${TEST_API}reward`;

export const CREATE_TOKEN_EVENT = `${TEST_API}create/event`;
export const GET_REWARDS_HISTORY = `${TEST_API}token/reward/previous?limit=6`;
export const GET_TOKEN_DETAILS = `${TEST_API}token/reward?previousEarningsLimit=6&isCreate=true`;
export const GET_MM = `${TEST_API}mm/rewards`;
//contest

export const CONTEST_DETAIL = `${TEST_API}${CONTEST_PREFIX}live?contest_id={contestId}`;
export const CONTEST_TOP_UP = `${TEST_API}${CONTEST_PREFIX}topupcontest`;
export const CONTEST_BALANCE = `${TEST_API}${CONTEST_PREFIX}balance?contest_id=`;
export const CONTEST_LEADERBOARD = `${TEST_API}fantasy/{contestId}/leaderboard`;
export const CONTEST_CLOSED_DETAIL = `${TEST_API}fantasy/{contestId}/event/outcomes`;
export const CONTEST_CHAT = `${TEST_API}fantasy/create_chat_user`;

//partner login

export const USER_PARTNER_PROFILE = `${TEST_API}partner/validatePayload`;

export const mmCancelAll = (data, isShowLoader) => {
    const url = `${TEST_API}probe/mmCancelAll`;
    return POST(url, data, null, isShowLoader, true);
}
